export default __webpack_public_path__ + "static/media/Immagine_2.3e715aba.jpg";